export const global = {
  isiPhoneX: false,
  getMargin: function () {
    if (this.isiPhoneX) { return 30 } else { return 0 }
  }

}



// WEBPACK FOOTER //
// ./src/app/global.ts